<template>
  <div id="app">
    <v-app>
      <TheHeader />

      <v-main class="grey lighten-4">
        <v-container
          fluid
          fill-height
          align-start
          justify-center
          class="pa-0 ma-auto"
          :style="{
            backgroundImage: 'url(' + bgImage + ')',
            backgroundRepeat: 'repeat',
            backgroundSize: '250px',
            backgroundAttachment: 'fixed'
          }"
        >
          <v-card width="900" flat color="rgb(0, 0, 0, 0)">
            <!--<keep-alive include="CountriesPage">-->
            <router-view></router-view>
            <!--</keep-alive>-->
          </v-card>

          <!--
          <v-row justify="center" align="start" no-gutters class="pa-0 ma-auto">
            <v-card width="800" align="start" class="pa-0 ma-auto transparent" flat>
              <keep-alive include="CountriesPage">
                <router-view></router-view>
              </keep-alive>
            </v-card>
          </v-row>
          -->
        </v-container>
        <NewVersionDialog></NewVersionDialog>
      </v-main>
      <TheFooter />
    </v-app>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import NewVersionDialog from '@/components/NewVersionDialog.vue'
export default {
  components: {
    TheHeader,
    TheFooter,
    NewVersionDialog
  },
  data() {
    return {
      bgImage: '/backgrounds/bg2.jpg'
    }
  }
}
</script>
